import { render, staticRenderFns } from "./TodoReceipt.vue?vue&type=template&id=c013a0a0&scoped=true&"
import script from "./TodoReceipt.vue?vue&type=script&lang=js&"
export * from "./TodoReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c013a0a0",
  null
  
)

export default component.exports